<template>
  <div id="app">
 

  <!-- <article class="depiction-wrap"></article> -->   
<router-view></router-view>


    
 

   

    
  </div>
</template>

<script>
  import HelloWorld from '@/components/page/HelloWorld'
  import Login from '@/components/page/login'
  import ProductDetailed from '@/components/page/productDetailed'



  // import page3 from'@/assets/js/coreNavigation.js'
  // import my from'@/assets/js/my.js'
    import page2 from'@/assets/js/jsManage.js'
  // import page from'@/assets/js/page.js'

  // import sider from'@/assets/js/sider.js'
  import classie from'@/assets/js/classie.js'
  import mui1 from'@/assets/js/minimal-slider.js'
  
  //import colorbox from'@/assets/js/colorbox.js'
 // import iframe from'@/assets/js/iframe.js'


  
  export default {
    name: 'App',
    components: {
      HelloWorld,
      Login,
      ProductDetailed,
    },
    data() {
      return {
      
      }
    }
  
  }
  

</script>

<style lang="scss">
  @import 'assets/css/all';
 /* 少了圖片
@import 'assets/css/Layout/reset.css';
@import 'assets/css/Layout/cms-header.css';
@import 'assets/css/Layout/index.css';
@import 'assets/css/Layout/cms-footer.css';
@import 'assets/css/Layout/slick.css';*/

</style>



// WEBPACK FOOTER //
// src/App.vue